<div class="row row-sm">
    <div class="col-lg-12">
        <div class="card-body">
            <div class="row">
                <div class="col-md-12" *ngIf="submitButton">
                    <div class="bc d-flex align-items-center pl-3">
                        <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>
                                {{'header.town-data.table.Town' | translate }}
                                </b></h3>
                            <p class="text-muted card-sub-title mb-0">
                                {{'header.town-data.table.AddNewTownRecord' | translate }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="editButton">
                    <div class="bc d-flex align-items-center pl-3">
                        <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>
                                {{'header.town-data.table.Town' | translate }}
                            </b></h3>
                            <p class="text-muted card-sub-title mb-0">
                                {{'header.town-data.table.UpdateTownRecord' | translate}}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="deleteButton">
                    <div class="bc d-flex align-items-center pl-3">
                        <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>
                                {{'header.town-data.table.Town' | translate }}
                            </b></h3>
                            <p class="text-muted card-sub-title mb-0">
                                {{'header.town-data.table.DeleteTownRecord' | translate}}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row row-sm add-form">
                    <form autocomplete="off" class="p-0" novalidate [formGroup]="TownForm ">
                        <div class="col-lg-12 col-md-12">
                            <div class="row mt-3 clearfix">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    {{'header.town-data.table.TownDsCode' | translate}}
                                                </mat-label>

                                                <mat-select [disabled]="isReadonlyDelete" required #select343
                                                    placeholder="TnDsCode" class="colorblack"
                                                    formControlName="TnDsCode">
                                                    <mat-select-filter *ngIf="select343.focused"
                                                        [placeholder]="'Filter'" [displayMember]="'DsName'"
                                                        [array]="townDistrictList"
                                                        (filteredReturn)="filteredListTownDistrict =$event"></mat-select-filter>
                                                    <mat-option onkeydown="return (event.keyCode!=13);"
                                                        *ngFor="let item of filteredListTownDistrict"
                                                        [value]="item.DsCode">
                                                        {{item.DsName}}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error class="margin_tp"
                                                    *ngIf="TownForm.controls['TnDsCode'].touched && TownForm.controls['TnDsCode'].errors?.required">
                                                    {{'header.town-data.table.Mandatory' | translate}}</mat-error>
                                            </mat-form-field>

                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    {{'header.town-data.table.TownCode' | translate}}
                                                </mat-label>
                                                <input appUppercase onkeydown="return (event.keyCode!=13);"
                                                    [readonly]="isReadonly || isReadonlyDelete" class="color"
                                                    type="text" placeholder="Town Code" formControlName="TnCode"
                                                    matInput required maxlength="5">
                                                <mat-error class="margin_tp"
                                                    *ngIf="TownForm.controls['TnCode'].touched && TownForm.controls['TnCode'].errors?.required">
                                                    {{'header.town-data.table.Mandatory' | translate}}
                                                </mat-error>
                                                <mat-error class="margin_tp"
                                                    *ngIf="TownForm.controls['TnCode'].touched && TownForm.controls['TnCode'].errors?.pattern">
                                                   {{'header.town-data.table.Invalid' | translate}}</mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>
                                                    {{'header.town-data.table.TownName' | translate }}
                                                </mat-label>
                                                <input appCamelcase onkeydown="return (event.keyCode!=13);" class="color" type="text"
                                                    placeholder="Town Name" [readonly]="isReadonlyDelete" maxlength="40"
                                                    formControlName="TnName" matInput required>
                                                <mat-error class="margin_tp"
                                                    *ngIf="TownForm.controls['TnName'].touched && TownForm.controls['TnName'].errors?.required">
                                                    {{'header.town-data.table.Mandatory' | translate}}
                                                </mat-error>
                                                <mat-error class="margin_tp"
                                                    *ngIf="TownForm.controls['TnName'].touched && TownForm.controls['TnName'].errors?.pattern">
                                                    {{'header.town-data.table.Invalid' | translate}} </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mb-2">
                                    <div class="col-sm-12">
                                        <button id="Save" type="button" *ngIf="submitButton && townCreate" class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                                        (click)="submit()">
                                        <span style="display: contents; align-items: center;">
                                            <img width="20vh" src="../../assets/img/save.gif"
                                                style="margin-right: 5px;">
                                            {{'header.town-data.table.Save' | translate }}
                                        </span>
                                    </button>
                                    <button id="Updateyqawv " type="button" *ngIf="editButton && townUpdate" class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                                    (click)="update()">
                                    <span style="display: contents; align-items: center;">
                                        <img width="29%" src="../../assets/img/edit1.gif"
                                            style="margin-right: 5px;">
                                       {{'header.town-data.table.Update' | translate }}
                                    </span>
                                </button>
                                <button type="button" *ngIf="deleteButton && townDelete" class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                                (click)="openConformationModalBox()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/trash.gif"
                                        style="margin-right: 5px;">
                                    {{'header.town-data.table.Delete' | translate }}
                                </span>
                            </button>
                                        <button type="button" [mat-dialog-close]="true"
                                            class="btn fr sz btn-primary btn-icon-text floatright mt-1">
                                            <span style="display: contents; align-items: center; margin-left:1rem;">
                                                <img width="23%" src="../../assets/img/turn-left.gif"
                                                    style="margin-right: 5px;">
                                                {{'header.town-data.table.Back' | translate }}
                                            </span>
                                        </button>

                                    </div>
                                    

                                </div>

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div> 